import { Group } from '@mantine/core';
import { ChartType } from '../../../store/financials-store/financials-store.type';
import { baseWhite, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';

type Props = {
  selectedChartType: ChartType;
  setSelectedChartType: (chartType: ChartType) => void;
};

const chartTypeMap: Record<ChartType, string> = {
  [ChartType.Pie]: 'Pie',
  [ChartType.Bar]: 'Bar',
  [ChartType.Line]: 'Line',
};

const iconMap: Record<ChartType, string> = {
  [ChartType.Pie]: 'pie_chart',
  [ChartType.Bar]: 'bar_chart',
  [ChartType.Line]: 'stacked_line_chart',
};

export const BreakdownControls = ({ selectedChartType, setSelectedChartType }: Props) => {
  return (
    <Group gap="xs">
      {[ChartType.Pie, ChartType.Bar].map((chartType) => (
        <Button
          size="xs"
          radius="xl"
          variant={chartType === selectedChartType ? 'secondary' : 'outline'}
          key={chartType}
          onClick={() => setSelectedChartType(chartType)}
          style={{ width: '75px' }}
          leftSection={
            <Icon
              name={iconMap[chartType]}
              color={chartType === selectedChartType ? baseWhite : secondaryBase}
              size={16}
            />
          }
        >
          {chartTypeMap[chartType]}
        </Button>
      ))}
    </Group>
  );
};
